import React from 'react'
import { Link } from "react-router-dom";
import axios from 'axios';
import logo from './logo.png';


const API_URL = process.env.REACT_APP_API_URL || "https://api.glyphstats.com/api/";

class Autoglyph extends React.Component{

	constructor(props) {
	    super(props);
	    this.state = {
	    	loading: true,
			autoglyph: [],
			temp:[],
			autoglyph_id: props.searchautoglyph,	    	
	    };
		for(let i=0;i<30;i++){
			this.state.temp.push(i)
		}
	}
	componentDidMount(){
		this._isMounted = true;
		axios.get(API_URL + 'autoglyphs/')
        .then(response => {
			if (!this._isMounted) return;
			this._loadingTimer = setTimeout(() => {
				if (this._isMounted) this.setState({ loading: false });
			}, 3000);
			this.setState({ autoglyph: response.data });
			this.props.getDefault(response.data);
        });
	}

	componentWillUnmount() {
		this._isMounted = false;
		if (this._loadingTimer) clearTimeout(this._loadingTimer);
	}

  	render(){
	    return(
			<div>	
				{
					this.state.loading?
					<section className="products">
						{
							this.state.temp.map((item, index) => (
								<div className="product-card" key={item}>
								    <div className="product-image">
										<div className="product-rarity">
											{/* # {item.rarity_score} */}
										</div>
										<img src={logo} alt="logo"/>
										<div className="product-info">
								    		{/* Autoglyph #{item.id} */}
										</div>
								    </div>

								</div>
						    ))}
					</section>
					:
					<section className="products">
						{
							this.state.autoglyph.map((item, index) => (
								<div className="product-card" key={item.id}>
								    <div className="product-image">
										
								      <Link
							              	to={{
							                	pathname: `/autoglyph-details/${item.id}`,
							              	}}
							            >
											<div className="product-info">
											<center>Autoglyph #{item.id}</center>
											</div>
											{!this.state.loading && <img src={`${item.autoglyph_image}`} alt="autoglyph" />}
						    			</Link>
						    			
						    			<div className="product-rarity">
											Rarity #{item.rarity_score}
								    	
										</div>
								    </div>

								</div>
						    ))}
					</section>
				}

				
	    		
			</div>
	    )
  }
}

export default Autoglyph;


// WEBPACK FOOTER //
// ./src/Autoglyph.js